import axios from "axios";
import { baseUrl } from "../config/api-config";

export function getNegotiationsAwaiting(token) {
  return axios.get(`${baseUrl}/negotiations/awaiting`, { headers: { authorization: token } });
}
